import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {addFlowKey, setFlowKey} from "../../../store/actions/display";
import { CSSTransitionGroup } from 'react-transition-group';

class PolyFlowContainer extends Component {
    componentWillMount() {
        this.props.addFlowKey();
    }

    render() {
        const keyedChildren = React.Children.map(this.props.children,
            (child, i) => React.cloneElement(child, {
                ...this.props.props,
                key: i
            })
        );

        if (this.props.flowKey) {
            const Wrapper = this.props.wrapper;
            const key = keyedChildren[this.props.flowKey.value].key;
            return Wrapper ? (
                <Wrapper id={this.props.id}>
                    <div className="polyflow-wrapper pb-5">
                        <CSSTransitionGroup
                            transitionName={this.props.flowKey.direction === 1 ? 'polyslide-r' : 'polyslide-l'}
                            transitionEnterTimeout={700}
                            transitionLeaveTimeout={400}>
                            <div className="polyflow-item" key={key}>
                                {keyedChildren[this.props.flowKey.value]}
                            </div>
                        </CSSTransitionGroup>
                    </div>
                </Wrapper>
            ) : (
                <div className="polyflow-wrapper pb-5">
                    <CSSTransitionGroup
                        transitionName={this.props.flowKey.direction === 1 ? 'polyslide-r' : 'polyslide-l'}
                        transitionEnterTimeout={700}
                        transitionLeaveTimeout={400}>
                        <div className="polyflow-item" key={key}>
                            {keyedChildren[this.props.flowKey.value]}
                        </div>
                    </CSSTransitionGroup>
                </div>
            );
        }
        else return null;
    }
}

PolyFlowContainer.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired
};

const mapStateToProps = (state, props) => ({
    flowKey: state.display.flowKeys.find(key => key.id === props.id)
});

const mapDispatchToProps = (dispatch, props) => ({
    addFlowKey() {
        return dispatch(addFlowKey(props.id, props.children.length, props.defaultFlowKey));
    },
    setFlowKey(id, value) {
        return dispatch(setFlowKey(id, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PolyFlowContainer);



// WEBPACK FOOTER //
// ./src/components/flow/PolyFlow/PolyFlowContainer.js